<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M13.525 5.691A3.5 3.5 0 0119.5 8.166v1.167a1 1 0 102 0V8.166a5.5 5.5 0 00-11 0v3.833H7c-.92 0-1.667.746-1.667 1.667v14c0 .92.746 1.667 1.667 1.667h18c.92 0 1.666-.746 1.666-1.667v-14c0-.92-.746-1.667-1.666-1.667H12.5V8.166a3.5 3.5 0 011.025-2.475zM7.333 14v13.334h17.333V13.999H7.333zm10 6.667a1.333 1.333 0 11-2.667 0 1.333 1.333 0 012.667 0z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsLockOpenOutline'
}
</script>
